import useRoleMutation from "~/pages/RegistryOfRole/hooks/useRoleMutation";

export default function useUpdateRole() {
  return useRoleMutation(
    "/internal-api/auth/access/role",
    (id) => (id === "add" ? "POST" : "PUT"),
    "getRole",
  );
}
